import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  OpenIdConfiguration,
  StsConfigHttpLoader,
  StsConfigLoader,
  provideAuth,
  withAppInitializerAuthCheck,
} from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

import { routes } from './app.routes';
import { authInterceptor } from '@core/auth/auth.interceptor';
import { AppConfigService } from '@core/services/app-config.service';

/**
 * IDP-08: scope includes 'offline_access' (ZITADEL refresh tokens) and
 * ignoreNonceAfterRefresh: true (ZITADEL omits id_token in refresh response).
 * Both are set inside AppConfigService.oidcConfig.
 */
export function oidcLoaderFactory(appConfig: AppConfigService): StsConfigHttpLoader {
  return new StsConfigHttpLoader(
    new Observable<OpenIdConfiguration>(observer => {
      appConfig.load()
        .then(() => { observer.next(appConfig.oidcConfig); observer.complete(); })
        .catch(err => observer.error(err));
    }),
  );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAuth(
      {
        loader: {
          provide: StsConfigLoader,
          useFactory: oidcLoaderFactory,
          deps: [AppConfigService],
        },
      },
      withAppInitializerAuthCheck(),
    ),
  ],
};
